import _ from 'lodash'
import { StepTreePathChain } from '../../features/stepTreePathChain'

export const addToPathList = (pathList: string[], path: string) => {
  return _.uniq([...pathList, path])
}

export function removePathAndAllSubpaths(pathList: string[], targetPath: string) {
  const targetPathChain = new StepTreePathChain(targetPath)

  const shouldRemove = (path: string) => {
    if (path === targetPath) return true
    if (targetPathChain.isParentOf(path)) return true
    return false
  }

  return pathList.filter(path => !shouldRemove(path))
}
